module.exports = __webpack_public_path__ + "img/efce464.jpg";